import { UniDriver } from '@wix/wix-ui-test-utils/dist/types/unidriver';
import { pageUniDriverFactory as publicDriverFactory } from './Page.uni.driver';
import { scrollableContainerPrivateUniDriverFactory } from '../common/ScrollableContainer/test/ScrollableContainer.private.uni.driver';

export const pagePrivateUniDriverFactory = (base: UniDriver) => {
  return {
    ...publicDriverFactory(base),
    _getScrollableContainerDriver: () =>
      scrollableContainerPrivateUniDriverFactory(
        base.$('[data-hook="page-scrollable-content"]'),
      ),
  };
};
